module.exports = __webpack_public_path__ + "img/Wanderschuhe.bd143dd8.png";